// extracted by mini-css-extract-plugin
module.exports = {"card":"categories_card__Ef9Ew"};